export default {
	PRODUCT_VARIANT_ADDON_ADDED: 'Product variant addon added.',
	PRODUCT_VARIANT_ADDON_EDITED: 'Product variant addon edited.',
	PRODUCT_VARIANT_ADDON_DELETED: 'Product variant addon deleted.',
};
